export enum ApplicationFormVariant {
    DEFAULT,
    CREDIT
}
export enum ApplicationFormVariant {
    DEFAULT,
    CREDIT
}
